import type { ChangeEvent } from 'react';
import {
  default as MuiTextField,
  type TextFieldProps as MuiTextFieldProps,
} from '@mui/material/TextField';

export interface TextFieldProps extends Omit<
  Partial<MuiTextFieldProps<'outlined'>>,
  'onChange'
> {
  autofill?: boolean;
  error?: boolean;
  label?: string;
  value: string;
  type?: MuiTextFieldProps['type'];
  onChange: (
    update: string,
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

export default function TextField({
  type = 'text',
  label = '',
  autofill = true,
  onChange,
  ...props
}: TextFieldProps) {
  return (
    <MuiTextField
      type={type}
      label={label}
      // NOTE: Browsers seem to ignore autoComplete="off" but respect autoComplete="new-password"
      autoComplete={autofill ? undefined : 'new-password'}
      variant="outlined"
      onChange={(e) => onChange(e.target.value, e)}
      {...props}
    />
  );
}
